export const PAYMENT_RESPONSE_ICON_VARIANT = {
  success: 'M5 13l4 4L19 7',
  fail: 'M6 18L18 6M6 6l12 12',
};
